<template>

<div>

    <app-header />


  <div class="container">

		<nav aria-label="breadcrumb">
			<ol class="breadcrumb">
				<li class="breadcrumb-item"><router-link :to="'/project/'+project.id">{{ project.name }}</router-link></li>
				<li class="breadcrumb-item"><router-link :to="'/project/'+project.id+'/tables'">{{ _lang('Collections') }}</router-link></li>
				<li class="breadcrumb-item active" aria-current="page">{{table.name}}</li>
				<li class="breadcrumb-item active" aria-current="page">{{ _lang('fields') }}</li>
			</ol>
		</nav>

      <table class="table" v-show="!formActive">
        <tbody>
          <tr v-for="(field,index) in table.fields">
            <td>{{ field.name }}</td>
            <td>{{ field.type }}</td>
            <td><span class="btn btn-light" v-show="index>0" @click="moveUpField(field)">▲</span></td>
            <td><span class="btn btn-light" v-show="index<table.fields.length-1" @click="moveDownField(field)">▼</span></td>
            <td><span class="btn btn-primary" @click="edit(field)">{{ _lang('Edit') }}</span></td>
          </tr>
        </tbody>
      </table>
      <div v-if="reordering">
        <button class="btn btn-primary" @click="onSubmitOrder">{{ _lang('Save order') }}</button>
      </div>

      <button class="btn btn-primary" v-show="!formActive" @click="addField">{{ _lang('Add field') }} </button>
      <span class="btn btn-light" v-show="!formActive" @click="goBack">{{ _lang('Back') }}</span>

      <form v-show="formActive" @submit.prevent="onSubmit">
        <div class="form-group">
          <label>{{ _lang('Name') }}</label>
          <input v-model="field.name" type="text" class="form-control" required>
        </div>

        <div class="form-group">
          <label>{{ _lang('Type') }}</label>
          <select v-model="field.type" class="form-control" required>
            <option value="text">Text</option>
            <option value="textarea">Textarea</option>
            <option value="wysiwyg">Text editor</option>
            <option value="image">Image</option>
            <option value="gallery">Gallery</option>
						<option value="file">File</option>
						<option value="multiple-file">Multiple Files</option>
            <option value="select">Select</option>
            <option value="multiselect">Multiselect</option>
            <option value="checkbox">Checkbox</option>
            <option value="currency">Currency</option>
            <option value="whatsapp_link">Whatsapp link</option>
            <option value="telephone_link">Telephone link</option>
            <option value="email_link">E-mail link</option>
            <option value="image-select">Image Select</option>
            <option value="relation">DB Relation</option>
						<option value="csvtable">{{ _lang('CSV Table')}}</option>
          </select>
        </div>

        <div class="form-group" v-if="field.type=='relation'">
          <label>{{ _lang('Collection') }}</label>
          <select class="form-control" required  :value="field.meta?field.meta.table:''" @change="setRelation($event.target.value)">
            <option v-for="table in tables" :value="table.id">{{table.name}}</option>
          </select>
        </div>

        <div class="row" v-if="field.type=='csvtable'">
					<div class="form-group col-6">
						<label>{{ _lang('Delimiter') }}</label>
						<input type="text" class="form-control" v-model="field.meta.delimiter" placeholder=",">
					</div>
				</div>


        <div class="row" v-if="field.type=='currency'">
					<div class="form-group col-6">
						<label>{{ _lang('Symbol') }}</label>
						<input type="text" class="form-control" v-model="field.meta.symbol" placeholder="Symbol">
					</div>
					<div class="form-group col-6">
						<label>{{ _lang('Format') }}</label>
						<select v-model="field.meta.format" class="form-control" required>
							<option value="(symbol) 9.999,99">(symbol) 9.999,99</option>
							<option value="(symbol) 9,999.99">(symbol) 9,999.99</option>
							<option value="9.999,99 (symbol)">9.999,99 (symbol)</option>
							<option value="9,999.99 (symbol)">9,999.99 (symbol)</option>
						</select>
					</div>
				</div>


        <div class="form-group" v-if="field.type=='select'">
          <div v-for="(option,index) in field.options">
            <div class="d-flex align-items-baseline">
              <div class="form-group mr-3">
                <label>{{ _lang('Name') }}</label>
                <input type="text" class="form-control" v-model="option.name">
              </div>
              <div class="form-group">
                <span :disabled="index==0" class="btn btn-sm btn-light" @click="arrayUp(field.options,index)">▲</span>
                <span :disabled="index==field.options.length-1" class="btn btn-sm btn-light" @click="arrayDown(field.options,index)">▼</span>
                <span class="btn btn-sm btn-light" @click="arrayRemove(field.options,index)">&times;</span>
              </div>
            </div>
          </div>
          <button @click.prevent="arrayAdd(field.options)" class="btn btn-sm btn-primary">{{ _lang('Add option') }}</button>

        </div>

        <div class="form-group" v-if="field.type=='multiselect'">
          <div v-for="(option,index) in field.options">
            <div class="d-flex align-items-baseline">
              <div class="form-group mr-3">
                <label>{{ _lang('Name') }}</label>
                <input type="text" class="form-control" v-model="option.name">
              </div>
              <div class="form-group">
                <span :disabled="index==0" class="btn btn-sm btn-light" @click="arrayUp(field.options,index)">▲</span>
                <span :disabled="index==field.options.length-1" class="btn btn-sm btn-light" @click="arrayDown(field.options,index)">▼</span>
                <span class="btn btn-sm btn-light" @click="arrayRemove(field.options,index)">&times;</span>
              </div>
            </div>
          </div>
          <button @click.prevent="arrayAdd(field.options)" class="btn btn-sm btn-primary">{{ _lang('Add option') }}</button>

        </div>

        <div class="form-group" v-if="field.type=='image-select'">

          <div v-for="(option,index) in field.options">
            <div class="d-flex align-items-baseline">
              <div class="form-group">
                <label>{{ _lang('Name') }}</label>
                <input type="text" class="form-control" v-model="option.name">
              </div>
              <div class="form-group mx-3">
                <label>{{ _lang('Image') }}</label>
                <x-image v-model="option.image" :key="option.image" style="max-height:50px;" />
              </div>
              <div class="form-group">
                <span :disabled="index==0" class="btn btn-sm btn-light" @click="arrayUp(field.options,index)">▲</span>
                <span :disabled="index==field.options.length-1" class="btn btn-sm btn-light" @click="arrayDown(field.options,index)">▼</span>
                <span class="btn btn-sm btn-light" @click="arrayRemove(field.options,index)">&times;</span>
              </div>
            </div>
          </div>
          <button @click.prevent="arrayAdd(field.options)" class="btn btn-sm btn-primary">{{ _lang('Add option') }}</button>

        </div>



        <div class="form-group">
          <label>
            <input type="checkbox" v-model="field.required">
            {{ _lang('Required') }}
          </label>
        </div>
				<div class="form-group">
          <label>
            <input type="checkbox" v-model="field.meta.hideAtListing">
            {{ _lang('Do not show on listing table') }}
          </label>
        </div>


        <button type="submit" class="btn btn-primary">{{ _lang('Save') }}</button>
        <span class="btn btn-light" @click="formActive = false">{{ _lang('Cancel') }}</span>
        <span v-if="field.id" class="btn btn-danger" @click="removeField(field.id)">{{ _lang('Delete') }}</span>


      </form>

    </div>
</div>

</template>
<script>

import axios from 'axios';
import appHeader from '../components/appHeader.vue'
import Image from '@/components/inputs/Image';

export default {
  props:['project_id','table_id'],
  components:{
		'x-image':Image,
    appHeader,
  },
  data() {
    return {
      table:{},
      formActive:false,
      reordering:false,
      field:{
        meta:{},
        options:[],
      }
    }
	},
	computed:{
		project(){
			return this.$store.state.project
		},
		tables(){
			return this.$store.state.project.tables
		}
	},
  methods:{
		setRelation(table){
			if(!this.field.meta) this.field.meta = {};
			this.field.meta.table = table;
		},

    moveUpField(field){
      var index = this.table.fields.indexOf(field);
      var field = this.table.fields.splice(index,1);
      this.table.fields.splice(index-1,0,field[0]);
      this.reordering = true;
    },
    moveDownField(field){
      var index = this.table.fields.indexOf(field);
      var field = this.table.fields.splice(index,1);
      this.table.fields.splice(index+1,0,field[0]);
      this.reordering = true;
    },
    onSubmitOrder(field_id){
      axios({
          method: 'post',
          url: '/api/fields/reorder',
          data:{fields:this.table.fields},
        }).then((res) => {
          this.formActive = false;
          this.getData();
          this.reordering = false;
        });
    },
    arrayAdd(arr){
      arr.push({});
    },
    arrayUp(arr,index){
        var cat = arr.splice(index,1);
        arr.splice(index-1,0,cat[0]);
    },
    arrayDown(arr,index){
        var cat = arr.splice(index,1);
        arr.splice(index+1,0,cat[0]);
    },
    arrayRemove(arr,index){
        arr.splice(index,1);
    },
    removeField(field_id){
      if(!confirm(this._lang('Delete field?'))) return;
      axios({
          method: 'Delete',
          url: '/api/fields/'+field_id,
        }).then((res) => {
          this.formActive = false;
          this.getData();
        });
    },


    goBack(){
      this.$router.go(-1);
      this.$router.push({ name: 'project-tables', params: { project_id:this.project_id} })
    },
    addField(){
      this.formActive = true;
      this.field = {options:[],meta:{}};
    },
    edit(field){

			this.field = field;
			if(!this.field.meta) this.field.meta = {};

      this.formActive = true;
    },

    onSubmit(){
        let data = {
            table_id:this.table_id,
            ...this.field,
        }

        axios({
          method: 'post',
          url: '/api/fields'+(data.id?`/${data.id}`:''),
          data: data
        }).then((res) => {
          this.formActive = false;
          this.getData();

        });

    },
    url(slug,page){
      var url = slug+'.'+process.env.VUE_APP_BASEURL;
      if(page) url += '/'+page.replace(/\/$/,'')
      return url;
    },
    dataBr(data){
      var d = new Date(data);
      return ('0'+d.getDate()).substr(-2) + '/' +('0'+(d.getMonth()+1)).substr(-2)+'/'+d.getFullYear();
    },

    getData(){

        axios({
            url: '/api/tables/'+this.table_id,
        }).then((res) => {
            this.table = res.data;
        });
    },

  },
  mounted(){
		this.getData();
		if(!this.project.id){
			this.$store.dispatch('getProject',this.project_id)
		}

  }

}



</script>

<style>

</style>
